import { Navigate, useParams } from 'react-router-dom';

const UTM = 'utm_source=whatsapp&utm_medium=manual_outreach';

// Short, readable links used in WhatsApp messages (/c/<code>, /book)
export const ShortLink = ({ to }) => {
  const { code } = useParams();
  const target = to === 'assessment'
    ? `/career-readiness-check?m=${encodeURIComponent(code)}&${UTM}`
    : `/apply?plan=clarity-session&${UTM}`;
  return <Navigate to={target} replace />;
};
